

/// <reference path="LedgerAccountBalance.ts" />

// Generated class PurchaseInvoiceLedgerAccountBalance_ManagedObject

class PurchaseInvoiceLedgerAccountBalance_ManagedObject extends LedgerAccountBalance
{
}
